import React from "react";
import Marquee from "react-fast-marquee";
import { FOOTER_SLIDER } from "./Helper";
import PrimaryHeading from "../custom-ui/PrimaryHeading";

// FooterSlider component for displaying a series of images in a slider
function FooterSlider() {
  return (
    <>
      {/* Desktop and larger screen slider */}
      <div className="xl:max-w-[1160px] xl:px-0 px-5 mx-auto container">
        <PrimaryHeading
          className="text-dark-purple xl:pb-24 lg:pb-16 pb-6 lg:pt-8 xl:pt-12 max-w-[1230px] mx-auto pt-8 text-center"
          children="Free NFT Mint with Special Perks"
        />
      </div>
      <div className="hidden max-w-[1808px] mx-auto ps-5 pe-7 2xl:px-8 lg:flex justify-between gap-3 lg:gap-7 xl:gap-9 2xl:gap-7 custom-1700:gap-5">
        <Marquee className="py-6" gradient={false} speed={150}>
          {FOOTER_SLIDER.map((obj, i) => (
            <div
              key={i}
              className={`2xl:max-w-[261px] max-w-[230px] mx-4 custom-1700:h-[339px] 2xl:h-[280px] h-[250px] rounded-[16px] lg:rounded-[20px] xl:rounded-[30px] lg:shadow-lgPurpleShadow shadow-mdPurpleShadow w-full ${
                i % 2 !== 0 ? "-mt-[16px] lg:-mt-[20px] xl:-mt-[34px]" : ""
              }`}
            >
              <img
                src={obj.src}
                alt="footer-slider-image"
                className="w-full h-full bg-dark-purple object-cover rounded-[14px] lg:rounded-[18px] xl:rounded-[28px] hover:scale-[1.05] duration-200 border-[2px] border-dark-purple"
              />
            </div>
          ))}
        </Marquee>
      </div>
      {/* Mobile screen slider */}
      <div className="lg:hidden">
        <Marquee className="pb-6" gradient={false} speed={70}>
          {FOOTER_SLIDER.map((obj, i) => (
            <div
              key={i}
              className={`mx-2 max-w-[120px] md:max-w-[160px] rounded-[16px] shadow-mdPurpleShadow w-full ${
                i % 2 !== 0 ? "mt-[16px]" : ""
              }`}
            >
              <img
                src={obj.src}
                alt="footer-slider-image"
                className="hover:scale-[1.05] rounded-[16px] min-h-[131px] md:min-h-[175px] duration-200 border-[2px] border-dark-purple"
              />
            </div>
          ))}
        </Marquee>
      </div>
    </>
  );
}

export default FooterSlider;
